import { render } from "./other-punishment-count.vue?vue&type=template&id=76810d10&scoped=true"
import script from "./other-punishment-count.vue?vue&type=script&lang=js"
export * from "./other-punishment-count.vue?vue&type=script&lang=js"

import "./other-punishment-count.vue?vue&type=style&index=0&id=76810d10&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76810d10"]])

export default __exports__